import { Exercise } from '../icons/Exercise/Exercise';
import { Motivation } from '../icons/Motivation/Motivation';
import { Setbacks } from '../icons/Setbacks/Setbacks';
import { Stress } from '../icons/Stress/Stress';

export const COACH_LIST_ITEMS = [
  {
    options: [
      {
        name: 'motivation',
        icon: <Motivation />,
      },
      {
        name: 'stress',
        icon: <Stress />,
      },
      {
        name: 'benefits',
        icon: <Exercise />,
      },
      {
        name: 'setbacks',
        icon: <Setbacks />,
      },
    ],
  },
  {
    options: [
      {
        name: 'demotivated',
        icon: <Motivation />,
      },
      {
        name: 'mindfulness',
        icon: <Stress />,
      },
      {
        name: 'exercise',
        icon: <Exercise />,
      },
      {
        name: 'consistent',
        icon: <Setbacks />,
      },
    ],
  },
  {
    options: [
      {
        name: 'fun',
        icon: <Motivation />,
      },
      {
        name: 'sleep',
        icon: <Stress />,
      },
      {
        name: 'workout',
        icon: <Exercise />,
      },
      {
        name: 'posture',
        icon: <Setbacks />,
      },
    ],
  },
  {
    options: [
      {
        name: 'goals',
        icon: <Motivation />,
      },
      {
        name: 'rest',
        icon: <Setbacks />,
      },
      {
        name: 'alone',
        icon: <Exercise />,
      },
      {
        name: 'hydration',
        icon: <Setbacks />,
      },
    ],
  },
];
